(function (global) {
    if (global.rlModule.rlVideoShow) {
        console.log('rlVideoShow is defined!');
        return;
    }

    global.rlModule.rlVideoShow = (function () {
        var _module = {};
        var _videodata = {};
        var _videoshowarea = {};

        var _videoPreviewData = {};
        var mp4Data = [];
        var _selectedIndex = -1;

        var imgpath = '';
        var mp4path = '';
        var numberOfRightCol = 6;

        $(function () {
            _videodata = $(".mp4-module");
            _videoshowarea = $(".rl-videoshow");
            imgpath = _videodata.data("imagepath");
            mp4path = _videodata.data("mp4path");
            numberOfRightCol = _videodata.data("number-of-right-cols");
            if ((_videodata.length > 0) && (_videoshowarea.length > 0)) {
                _module.renderUI();
            }
        });

        _module.renderUI = function () {
            _videoPreviewData = $("PreviewData").find("VideoInfo");

            $.when(appendData(_videoPreviewData)).then(function () {
                $("._thumbnail").click(function () {
                    if (_selectedIndex !== -1) {
                        var _lastSelectedObj = $("#mp4-container").find('._thumbnail').eq(_selectedIndex);
                        $(_lastSelectedObj).children('img').attr('src', getImagePath($(_videoPreviewData[_selectedIndex]).find("Name").text(), false));
                    }
                    _selectedIndex = $(this).data("index");

                    $("#mp4video").addClass("loading");
                    var _mp4 = $(_videoPreviewData[_selectedIndex]);
                    $("#mp4name").html(_mp4.find("Name").text());
                    $("#mp4desc").html(_mp4.find("Desc").text());
                    $("#mp4video").attr("src", mp4path + _mp4.find("Name").text() + ".mp4");
                    $(this).children('img').attr('src', getImagePath($(_videoPreviewData[_selectedIndex]).find("Name").text(), true));

                });

                $("._thumbnail").eq(0).trigger('click');

                $("#mp4video").bind('loadeddata', function (e) {
                    $(this).removeClass("loading");
                });

                var $slick_slider = $('#mp4-container');
                var settings = {
                    infinite: false,
                    dots: true,
                    slidesToShow: 5,
                    slidesToScroll: 5,
                }
                if (window.innerWidth < 767) {
                    $slick_slider.slick(settings);
                }

                $(window).on('resize', function () {
                    if (window.innerWidth > 767) {
                        if ($slick_slider.hasClass('slick-initialized')) {
                            $slick_slider.slick('unslick');
                        }
                        return
                    }
                    if (!$slick_slider.hasClass('slick-initialized')) {
                        return $slick_slider.slick(settings);
                    }
                });
            });
        }

        function appendData(_arrayData) {
            var deferred = $.Deferred();
            for (var index = 0; index < _arrayData.length; index++) {
                var videoPreviewData = _arrayData[index];
                $("#mp4-container").append("<div class='_thumbnail' data-index=" + index + " style='width: calc( 100% / " + numberOfRightCol + ");'><img src='" + getImagePath($(videoPreviewData).find("Name").text(), false) + "'></div>");
            }

            deferred.resolve();
            return deferred.promise();
        }

        function getImagePath(name, selected) {
            if (selected) {
                return imgpath + name + "-1.jpg";
            }
            else {
                return imgpath + name + ".jpg";
            }
        }

        return _module;
    })();
})(window);